import { FactoryProvider } from '@angular/core';
import { AgWidgetConfig, Settings } from '@mri-platform/shared/core';

export const AgWidgetConfigProvider: FactoryProvider = {
  provide: AgWidgetConfig,
  useFactory: (settings: Settings) => new AgWidgetConfig({ ...settings.agWidget, interceptNavigation: true }),
  deps: [Settings]
};
